import React, { Component } from 'react'
import {Link, StaticQuery, graphql} from 'gatsby'
import abstractMenu from './abstractMenu'

//Can't dynamically change staticquery, so just making a basic
//component here for TULSA and then another for other menu items
class TulsaMenu extends Component {

  render(){
    let tulsaOut = <StaticQuery
    query={graphql`
        query {
            allNodeTulsa(sort: {order: ASC, fields: title}) {
                nodes {
                    title
                    fields {
                        slug
                    }
                }
            }
        }
    `}
    render={data => {
        let nodes = data.allNodeTulsa.nodes
        let filtered = nodes.filter(link => 
            link.title !== 'Benign Prostate Disease' &&
            link.fields.slug !== '/prostate-101/benign-prostate-disease/' &&
            link.title !== 'Ablation Registry Trial' &&
            link.fields.slug !== '/tulsa/care-registry-trial/'
        )
        let output = filtered.map((link, i)=>{
            return (
                <li key={i}><Link className="button" to={link.fields.slug}>{link.title}</Link></li>
            )
        })
        return output
    }}/>

    if(!this.props.mobile){
      return (
        <li className="tulsa-menu" onMouseOver={() => {
            this.props.setMenu({menu: true}, ()=> {
                document.addEventListener('click', this.props.hideDropdownMenu)
            })
        }} onMouseOut={() => {
            this.props.setMenu({menu: false})
        }}><Link to="/tulsa">TULSA Procedure</Link>
          <ul className={`tulsa-inner-menu ${this.props.menu ? 'show': 'hide'}`} onMouseOut={() => {
              this.props.setMenu({menu: false})
          }}>
              <li><Link className="button" to="/tulsa/">Overview</Link></li>
             {tulsaOut}
              <li><Link className="button" to="/tulsa/case-study/">Case Study</Link></li>
          </ul>
        </li>
      )
    }else {
      return (

        <li><a href='#' onClick={e => {
            e.preventDefault()
            this.props.setMenu({menu: true}, ()=> {
                document.addEventListener('click', this.props.hideDropdownMenu)
            })

        }}>TULSA Procedure</a>
          <ul className={`${this.props.menu ? 'show': 'hide'}`} >
             <li><Link className="button" to="/tulsa/">Overview</Link></li>
             {tulsaOut}
             <li><Link className="button" to="/tulsa/case-study/">Case Study</Link></li>
          </ul>
        </li>
      )
    }
  }
}

export default abstractMenu(TulsaMenu)
